import React from "react";
import { CiSearch } from "react-icons/ci";
import Tooltip from "../Tooltip/tooltip";

interface EcoBookHeaderProps {
  filterText: string;
  setFilterText: React.Dispatch<React.SetStateAction<string>>;
}

const EcoBookHeader: React.FC<EcoBookHeaderProps> = ({ filterText, setFilterText }) => {
  

  return (
    <div className="bg-autoLayout overflow-hidden rounded-lg bg-cover bg-no-repeat p-12 text-center h-[285px] w-full">
      <div className="flex h-full items-center justify-center flex-col">
        <h1 className=" font-NotoSans text-center leading-8 text-white text-[14px] font-semibold ">
          Find your community on Ecomoto
        </h1>
        <div>
          <h3 className=" font-NotoSans text-center text-white text-[10px] font-medium">
            From vehicles, to learning, there's a place for you.
          </h3>
        </div>
        <div className="relative mt-4 w-[70%] lg:w-[50%]">
          <input
            type="text"
            value={filterText}
            placeholder="Explore Community"
            className="rounded-full shadow w-full h-7 p-2 text-exploreCol font-NotoSans text-[11px] font-medium outline-none"
            onChange={(e) => {
              setFilterText(e.target.value);
            }}
          />
          <div className="absolute w-4 right-1 top-[6px]">
            <Tooltip tooltip="search" >
              <CiSearch className=" text-exploreCol"/>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EcoBookHeader;
